import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({
  value,
  onChange,
  placeholder = "Enter description...",
  height = "400px",
  error = false,
  disabled = false,
  className = "",
  onBlur,
  toolbarId
}) => {
  const modules = useMemo(() => ({
    toolbar: toolbarId ? { container: `#${toolbarId}` } : [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
  }), [toolbarId]);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'color', 'background',
    'align'
  ];

  return (
    <div className={`rich-text-editor-container ${className}`}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={disabled}
        onBlur={onBlur}
        style={{ height: height }}
      />
      {error && (
        <p className="text-sm text-red-600 mt-2">{error}</p>
      )}
      <style jsx global>{`
        .rich-text-editor-container .ql-container.ql-snow {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          font-size: 14px;
        }
        .rich-text-editor-container .ql-toolbar.ql-snow {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          border-bottom: none;
        }
        .rich-text-editor-container .ql-editor {
          min-height: 200px;
        }
        /* Link Tooltip Fixes */
        .ql-snow .ql-tooltip {
          z-index: 1000 !important;
          border-radius: 8px !important;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
          border: 1px solid #e5e7eb !important;
          padding: 8px 12px !important;
          background: white !important;
          left: 5% !important;
        }
        .ql-snow .ql-tooltip input[type=text] {
          border: 1px solid #d1d5db !important;
          border-radius: 6px !important;
          padding: 6px 10px !important;
          font-size: 13px !important;
          width: 170px !important;
          margin-right: 8px !important;
          outline: none !important;
        }
        .ql-snow .ql-tooltip input[type=text]:focus {
          border-color: #10b981 !important;
          ring: 2px #10b981 !important;
        }
        .ql-snow .ql-tooltip .ql-action {
          color: #10b981 !important;
          font-weight: 600 !important;
        }
        .ql-snow .ql-tooltip .ql-remove {
          color: #ef4444 !important;
          margin-left: 8px !important;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
